import type { Zone } from '@seek/audience-zones';
import type { Language } from '@seek/melways-sites';

export function getZoneUrls(zone: Zone, language: Language) {
  const contactUrl = `https://${productionHostName[zone]}${
    language !== 'en' ? `/${language}` : ''
  }/contact-us/`;

  const helpCentreUrl = `https://${candidateHelpCentreHostNames[zone]}${
    language !== 'en' ? `/${language}` : ''
  }`;

  return {
    contactUrl,
    helpCentreUrl,
  };
}

/**
 * Production Host names that are used for notifications
 * Following decision from https://myseek.atlassian.net/browse/UPH-362
 */
const productionHostName: Record<string, string> = {
  'anz-1': 'www.seek.com.au',
  'anz-2': 'www.seek.co.nz',
  'asia-1': 'hk.jobsdb.com',
  'asia-3': 'th.jobsdb.com',
  'asia-4': 'www.jobstreet.co.id',
  'asia-5': 'www.jobstreet.com.my',
  'asia-6': 'www.jobstreet.com.ph',
  'asia-7': 'www.jobstreet.com.sg',
};

const candidateHelpCentreHostNames: Record<string, string> = {
  ['anz-1']: 'help.seek.com.au',
  ['anz-2']: 'help.seek.co.nz',
  ['asia-1']: 'help.hk.jobsdb.com',
  ['asia-3']: 'help.th.jobsdb.com',
  ['asia-4']: 'help.jobstreet.co.id',
  ['asia-5']: 'help.jobstreet.com.my',
  ['asia-6']: 'help.jobstreet.com.ph',
  ['asia-7']: 'help.jobstreet.com.sg',
};
